<template>
  <ClientOnly>
    <div ref="wrapperRef">
      <div
        class="fb-share-button"
        :data-href="locationPath"
        data-layout="button_count"
        data-size="small"
      >
        <a
          target="_blank"
          :href="`https://www.facebook.com/sharer/sharer.php?u=${encodedLocationPath}&src=sdkpreparse`"
          class="fb-xfbml-parse-ignore"
          >シェアする</a
        >
      </div>
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
const wrapperRef = ref<HTMLDivElement>();

const locationPath = ref('');
const encodedLocationPath = computed(() => {
  return encodeURIComponent(locationPath.value);
});

onMounted(async () => {
  // 後からウィジェットを発火させる
  // ref: https://developers.facebook.com/docs/javascript/reference/FB.init/v19.0
  await nextTick();
  locationPath.value = location.href;

  // 描画に失敗したときにページ全体がエラーになってしまうので、try/catchを挟む
  try {
    if (window.FB) {
      window.FB.XFBML.parse(wrapperRef.value);
    }
  } catch (e) {
    console.warn('FB.XFBML.parse failed:', e);
  }
});
</script>
